module.exports = __webpack_public_path__ + "static/media/animated-es.5295c138.gif";